export default __webpack_public_path__ + "12b8506fcb40dfb282d4e8e7fdb38d60.arrow-mobile.svg";